import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_B2B_BIZ_USER, IS_ONPREMISE, IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';

// CLOUDWEB-19356
// Убрать из диалога в чистилке кнопку "Удалить"
export const hideDeleteAb: boolean = !IS_PHONE_BROWSER && !IS_ONPREMISE && !IS_B2B_BIZ_USER && isFeature('hide-del-ab-clear');
